export default "__VITE_ASSET__DOe$jIyA__"